export default "__VITE_PUBLIC_ASSET__2d6a207f__"